import { render, staticRenderFns } from "./PhoneFieldWithValidation.vue?vue&type=template&id=2a2c06d9&lang=pug&"
import script from "./PhoneFieldWithValidation.vue?vue&type=script&lang=ts&"
export * from "./PhoneFieldWithValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports